import { VehicleDetailResponse } from "models/vehicleResponse";
import { Suspense, useRef, useState } from "react";
import { cloudinaryLoaderImage, cloudinaryLoaderVDPImages, defaultLoader } from "utils/cloudinaryUtils";
import { numberWithCommas, onlyNumbers, isEmpty } from "utils/commonUtils";
import useImageUtil from "utils/ImageUtil";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useIntersectionObserver from "components/Hooks/useIntersectionObserver";
import PanelInfoCollapsable from "./PanelInfoCollapsable";
import { gaevent } from "components/GAEvent/gaevent";
import TrueFramePlugin from "./TrueFramePlugin";

const ImageFuture = dynamic(() => import("next/image"));
const CheckAvailabiltyButton = dynamic(
    () => import("components/vehicles/VDP/CheckAvailabiltyButton")
);
const SocialOptions = dynamic(
    () => import("components/vehicles/VDP/SocialOptions")
);
const DetailVehicle = dynamic(
    () => import("components/vehicles/VDP/DetailVehicle")
);
const InstantQuotePlugin = dynamic(
    () => import("components/vehicles/VDP/InstantQuotePlugin")
);
const SimilarVehicles = dynamic(() => import("components/vehicles/VDP/SimilarVehicles"));
const SimilarVehiclesCarousel = dynamic(() => import("components/vehicles/VDP/SimilarVehiclesCarousel"));
const SoldVehicleImage = dynamic(
    () => import("components/vehicles/VDP/SoldVehicleImage")
);

const CapitalOnePlugin = dynamic(
    () => import("components/vehicles/VDP/CapitalOnePlugin")
);
const CarfaxPlugin = dynamic(
    () => import("components/vehicles/VDP/CarfaxPlugin")
);
const DealerCenterPlugin = dynamic(
    () => import("components/vehicles/VDP/DealerCenterPlugin")
);
const EdmundsPlugin = dynamic(
    () => import("components/vehicles/VDP/EdmundsPlugin")
);
const FinancingButton = dynamic(
    () => import("components/vehicles/VDP/FinancingButton")
);
const KbbChartPlugin = dynamic(
    () => import("components/vehicles/VDP/KbbChartPlugin")
);
const KbbIcoPlugin = dynamic(
    () => import("components/vehicles/VDP/KbbIcoPlugin")
);
const MonroneyLabel = dynamic(
    () => import("components/vehicles/VDP/MonroneyLabelPlugin")
);
const PureCarsPlugin = dynamic(
    () => import("components/vehicles/VDP/PureCarsPlugin")
);

const ButtonLink = dynamic(() => import("components/ButtonLink/ButtonLink"));
const HtmlComponent = dynamic(() => import("components/Html/Html"));
const PaymentCalculatorForm = dynamic(
    () => import("components/PaymentCalculator/PaymentCalculatorForm")
);
const SwiperImage = dynamic(() => import("components/SwiperImage/SwiperImage"));
const Loading = dynamic(() => import('components/Loading'));
const ShareButton = dynamic(() => import('components/ShareButton'), { ssr: false });

const VDPDesktop = ({
    srpSettings,
    vdpSettings,
    companyInfo,
    detailOptions,
    detail,
    textToShare,
}: {
  vdpSettings: any;
  companyInfo: any;
  srpSettings: any;
  thirdParty: any;
  detailOptions: any;
  detail: VehicleDetailResponse;
  textToShare: string;
}) => {
    const [tabActive, setTabActive] = useState(0);
    const router = useRouter();

    const {
        useLesaVideo,
        showLesaVideoInVDP,

        // useCarfax,
        useCarfaxInVDP,
        partnerIdCarfax,
        carfaxImageUrl,

        useMonroneyLabel,
        useMonroneyLabelInVDP,
        // scriptMonroneyLabel,
        idMonroneyLabel,

        // useMakeMyDeal,
        // useMakeMyDealInVDP,

        useTrueFrame360,
        useTrueFrame360InVDP,
        trueFrame360Script,

        useEdmundsInVDP,

        useOrbeeAuto,
        idOrbeeAuto,
        showOrbeeInVDP,
        showOrbeeInSimilar,

        useDealerCenter,
        useDealerCenterInVDP,

        // useKBB,
        // useKBBPrice,
        // useKBBICO,
        // showKBBICOInVDP,
        urlKBBICO,
        apiKeyKbb,
        showKBBPriceChart,
        showKBBICO,

        useCapitalOne,
        useCapitalOneInVDP,
        useCapitalOnePaymentCalculatorInVDP,
        useCapitalOnePrequalifiedInVDP,
        codeCapitalOne,

        useInstantQuote,
        useInstantQuoteInVDP,
        // hashInstantQuote,

        // showFilterCreditScore,
        // showFilterPayment,
        // showFilterVehiclePrice,
        // showFilterMileage,
        // showFilterYear,
        // showFilterStyle,
        // showFilterMake,
        // showFilterModel,
        // showFilterTransmission,
        // showFilterLocation,
        // showGridListOption,
        stockPhoto,
        forceImageOverSSL,
    
        imageValue,

        showVehiclePrice,
        showSimilarVehicles,
        similarCarsToShow,
        showSimilarVehiclesInCarousel,
        showVehicleOptions,
        showStandardEquipment,
        showOptionalEquipment,
        showAdditionalSpecifications,
        showDisclaimer,
        disclaimer,
        showPaymentCalculator,
        showSocialOptions,

        showCheckAvailabilityButton,
        checkAvailabilityButtonText,
        gaCheckAvailabilityCustomCategory,
        gaCheckAvailabilityCustomAction,
        gaCheckAvailabilityCustomLabel,
        gaCheckAvailabilityCustomValue,

        showApplyFinancingButton,
        applyFinancingButtonText,
        gaFinanceCustomCategory,
        gaFinanceCustomAction,
        gaFinanceCustomLabel,
        gaFinanceCustomValue,

        showPhoneCallButton,
        phoneCallButtonText,
        gaPhoneCallCustomCategory,
        gaPhoneCallCustomAction,
        gaPhoneCallCustomLabel,
        gaPhoneCallCustomValue,

        actionButtons,
        showSimilarVehiclesMiles,
        showSimilarVehiclesLocation,
        showSimilarVehiclesPrice,
        showVehicleSlashedPrice,
        overrideSimilarVehiclesPriceByText,
        overrideSimilarVehiclesPriceText,

        isSold,
        images,
        // showMonroyOrCarxInRow,
        showPureCarsValueReport,
        defaultImageAsThumbnail,
        lotInfo,
    } = detailOptions;

    const { renderImage } = useImageUtil({
        stockPhoto,
        forceImageOverSSL,
    });

    const standardOptions = detail?.features?.filter(
        (c: any) => c?.category?.toLowerCase() === "standard"
    );
    const optionalOptions =
    detail?.features?.filter(
        (c: any) => c?.category?.toLowerCase() === "optional"
    ) ?? [];
    const additionalOptions =
    detail?.features?.filter(
        (c: any) => c?.category?.toLowerCase() === "additional spec"
    ) ?? [];
    const vehicleOptions =
    detail?.features?.filter(
        (c: any) => c?.category?.toLowerCase() === "vehicle options"
    ) ?? [];

    const altImage = `${companyInfo.companyName} - Used ${detail.make} ${detail.model} ${detail.year} ${detail.lotName} ${detail.trim}`;

    const additionalOptionsHalf = additionalOptions.length<6 ? additionalOptions.length : Math.ceil(additionalOptions.length / 2);

    const similarSection = useRef(null);
    const isSimilarVehicleVisible = useIntersectionObserver(showSimilarVehicles && showSimilarVehiclesInCarousel ? similarSection:  null);

    const vehicleOptionSectionRef = useRef(null);
    const vehicleOptionSectionVisible = useIntersectionObserver(showVehicleOptions && vehicleOptions.length > 0 ? vehicleOptionSectionRef : null);

    const phoneOnlyNumber = onlyNumbers(isEmpty(phoneCallButtonText) ? lotInfo.lotPhone : phoneCallButtonText);
    const phoneText =  isEmpty(phoneCallButtonText) ? lotInfo.lotPhone : phoneCallButtonText;
    const phoneLink = `+1${phoneOnlyNumber}`;

    const onBackToResult = () => {
        if (document.referrer?.includes('/vehicles')) {
            router.back();
        }
        else {
            router.push('/vehicles');
        }
    };

    return (
        <>
            <div className="row" style={{ paddingBottom: "10px" }}>
                <div className="col-xs-6" style={{ color: "#464242", cursor: 'pointer' }}>
                    <i className="fa fa-angle-left"></i>&nbsp;&nbsp;
                    <span onClick={onBackToResult}>Back to Results</span>
                </div>
            </div>
            <div className="row">
                {showSimilarVehicles && !showSimilarVehiclesInCarousel && (
                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12 similar-vehicles-section onlydesktop">
                        <h2 className="text-center p-t-10 m-b-0 gray-bg">Similar Vehicles</h2>
                        <SimilarVehicles
                            stockNumber={Number(detail.stockNumber)}
                            options={{
                                defaultImageAsThumbnail,
                                stockPhoto,
                                forceImageOverSSL,
                                showSimilarVehiclesMiles,
                                showSimilarVehiclesLocation,
                                showSimilarVehiclesPrice,
                                showVehicleSlashedPrice,
                                overrideSimilarVehiclesPriceByText,
                                overrideSimilarVehiclesPriceText,
                                useOrbeeAuto,
                                showOrbeeInSimilar,
                                idOrbeeAuto,
                                similarCarsToShow,
                            }}
                            companyInfo={companyInfo}
                        />
                    </div>
                )}

                <div
                    className={
                        showSimilarVehiclesInCarousel
                            ? "col-lg-8 col-md-8 col-sm-8 col-xs-12"
                            : "col-lg-6 col-md-6 col-sm-6 col-xs-12"
                    }
                >
                    {isSold && <SoldVehicleImage companyName={companyInfo.companyName} />}
                    <div className="row">
                        <div className="col-md-12 vdp-desktop-img">
                            {images.length === 0 && (
                                <ImageFuture
                                    loader={defaultLoader}
                                    className="img-responsive"
                                    src={renderImage("")}
                                    width={750}
                                    height={420}
                                    alt={altImage}
                                />
                            )}

                            {images.length > 0 && (
                                <SwiperImage
                                    images={images}
                                    altImage={altImage}
                                    showThumbs={true}
                                    width={750}
                                    height={420}
                                    useNavigation={true}
                                    loader={cloudinaryLoaderVDPImages}
                                    slidesPerView={1}
                                    usePagination={false}
                                    shouldResizeImg={detail.hasResizedImages}
                                />
                            )}
                            {useOrbeeAuto && idOrbeeAuto && showOrbeeInVDP
                            && <div className="ax-save-favorite-detail" dangerouslySetInnerHTML={{__html: `<orb data-plugin-id=${idOrbeeAuto}
                                data-type="favorites-toggle"
                                data-vin=${detail.vin}>
                            </orb>`}} />
                            }
                        </div>
                        <div className="col-md-12 p-t-10">
                            <div className="col-md-4 no-padding text-center">
                                <div className="col-md-12 visitcounterdiv">
                                    <i className="fa fa-eye"></i>
                                    <span id="visitcounter"  className="vdp-access-link"></span>
                                </div>
                            </div>
                            <div className="col-md-4 copyLinkToolTip text-center"> 
                                <ShareButton text={textToShare} />
                            </div>
                            <div className="col-md-4 text-center">
                                <div className="sharediv">
                                    <a style={{color:'#333'}} href={`/locations?#${detail.lotName}`} target="_blank" rel="noreferrer">
                                        <i className="fa fa-map"></i>
                                        <span  className="vdp-access-link">
                                        Get Directions
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <main id="vehicleinfosectionid"></main>
                    {showVehicleOptions && vehicleOptions.length > 0 && (
                        <div className="m-t-20 grey-box" ref={vehicleOptionSectionRef}>
                            {vehicleOptionSectionVisible &&
                    <Suspense>
                        <h2 className="title"> Key Features</h2>
                        <div className="row">
                            {vehicleOptions.map((item: any, index: number) => (
                                <div className="col-md-4 kf-list-style-2" key={index}>
                                    {item.icon && (
                                        <ImageFuture
                                            loader={cloudinaryLoaderImage}
                                            className="keyfeaturesicon"
                                            src={item.icon} 
                                            alt={item.description}
                                            width={25}
                                            height={25}
                                            loading="lazy"
                                            unoptimized
                                        />
                                    )}

                                    {!item.icon && (
                                        <i
                                            className="fa fa-check"
                                            style={{
                                                fontSize: "23px",
                                                color: "var(--skin-base-color)",
                                            }}
                                        ></i>
                                    )}

                                    <span className="fk-desc">{item.description}</span>
                                </div>
                            ))}
                        </div>
                    </Suspense>
                            }
                        </div>
                    )}

                    <div>
                        {((companyInfo.companyCode === 1 &&
                    detail?.description?.length > 0) ||
                    companyInfo.companyCode !== 1) && (
                            <PanelInfoCollapsable
                                panelStyle="grey-box"
                                showCollapseButton={false}
                                title="General Information" >
                                <div className="col-md-12">
                                    {companyInfo.companyCode !== 1 &&
                        !detail.description &&
                        "No description available"}

                                    {detail.description && (
                                        <HtmlComponent htmlValue={detail.description} />
                                    )}
                                </div>
                            </PanelInfoCollapsable>
                        )}
                    </div>

                    {useLesaVideo && showLesaVideoInVDP && (
                        <div
                            id="les_video"
                            className={images.length > 0 ? "hasthumbnails" : ""}
                        ></div>
                    )}

                    {((showStandardEquipment && standardOptions.length > 0) ||
          (showOptionalEquipment && optionalOptions.length > 0) ||
          (showAdditionalSpecifications && additionalOptions.length > 0)) && (
                        <PanelInfoCollapsable
                            panelStyle="grey-box"
                            showCollapseButton={false}
                            showTitle={false}
                            title="" >
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12" style={{marginBottom: '-10px'}}>
                                    <div id="tabs">
                                        <ul className="tabs">
                                            {showStandardEquipment && standardOptions.length > 0 && (
                                                <li
                                                    data-tabs="vdptab2"
                                                    className={tabActive === 0 ? "active" : ""}
                                                    onClick={() => setTabActive(0)}
                                                > Standard Equipment </li>
                                            )}

                                            {showOptionalEquipment && optionalOptions.length > 0 && (
                                                <li
                                                    data-tabs="vdptab3"
                                                    className={tabActive === 1 ? "active" : ""}
                                                    onClick={() => setTabActive(1)}
                                                > Optional Equipment </li>
                                            )}

                                            {showAdditionalSpecifications &&
                    additionalOptions.length > 0 && (
                                                <li
                                                    data-tabs="vdptab4"
                                                    className={tabActive === 2 ? "active" : ""}
                                                    onClick={() => setTabActive(2)}
                                                > Additional Specifications </li>
                                            )}
                                        </ul>

                                        {showStandardEquipment && standardOptions.length > 0 && (
                                            <div
                                                id="vdptab2"
                                                className={`tabcontent ${tabActive === 0 ? "" : "hidden"}`}
                                            >
                                                {standardOptions.map((item: any, index: number) => (
                                                    <div className="col-md-4 list-style-1" key={index}>
                                                        <i className="fa fa-check"></i> {item.description}
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {showOptionalEquipment && optionalOptions.length > 0 && (
                                            <div
                                                id="vdptab3"
                                                className={`tabcontent ${tabActive === 1 ? "" : "hidden"}`}
                                            >
                                                {optionalOptions.map((item: any, index: number) => (
                                                    <div className="col-md-4 list-style-1" key={index}>
                                                        <i className="fa fa-check"></i> {item.description}
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {showAdditionalSpecifications && additionalOptions.length > 0 && (
                                            <div
                                                id="vdptab4"
                                                className={`tabcontent ${tabActive === 2 ? "" : "hidden"}`}
                                            >
                                                <table className="table-bordered col-md-6 col-lg-6">
                                                    <tbody>
                                                        {additionalOptions.slice(0, additionalOptionsHalf).map(
                                                            (
                                                                item: any, // tomar skip 0 FeatureVehicle item in detail.FeatureList.Where(c => c.Category.ToLower() == "additionalspec").Skip(0).Take(totaladditional))
                                                                index: number
                                                            ) => (
                                                                <tr key={index}>
                                                                    <th scope="row">{item.title}</th>
                                                                    <td>{item.description}</td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                                <table className="table-bordered col-md-6 col-lg-6">
                                                    <tbody>
                                                        {additionalOptions.length > 5 && additionalOptions.slice(additionalOptionsHalf, additionalOptions.length).map(
                                                            (
                                                                item: any,
                                                                index: number
                                                            ) => (
                                                                <tr key={index}>
                                                                    <th scope="row">{item.title}</th>
                                                                    <td>{item.description}</td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </PanelInfoCollapsable>
                    )}
                </div>
                <div
                    className={
                        showSimilarVehiclesInCarousel
                            ? "col-lg-4 col-md-4 col-sm-4 col-xs-12"
                            : "col-lg-3 col-md-3 col-sm-3 col-xs-12"
                    }
                >
                    <div className="car-details-sidebar">
                        <div className="grey-box">
                            <h1>
                                {detail.year} {detail.make} {detail.model}
                                <br />
                                {showVehiclePrice && detail?.internetPrice > 0 && (
                                    <strong>${numberWithCommas(detail.internetPrice)}</strong>
                                )}
                                <br />
                                <HtmlComponent htmlValue={vdpSettings.priceDisclaimer} />
                            </h1>

                            <DetailVehicle vdpSettings={vdpSettings} detail={detail} companyInfo={companyInfo} />
                        </div>

                        {/* si no esta vendido */}
                        {!detail.isSold && (
                            <>
                                <div className="grey-box m-t-20">
                                    <div className="details-phone details-weight">
                                        {showPhoneCallButton && <div className="row">
                                            <div className="col-md-12 col-sm-12">
                                                <a
                                                    className="calltonumbervdpid"
                                                    href={`tel: ${phoneLink}`}
                                                    onClick={()=> {
                                                        (gaPhoneCallCustomCategory && gaPhoneCallCustomLabel) ? gaevent({action: gaPhoneCallCustomAction ?? 'Click', category: gaPhoneCallCustomCategory, label: gaPhoneCallCustomLabel, value: gaPhoneCallCustomValue }) : null;
                                                    }}
                                                >
                                                    <div className="feature-box-3">
                                                        <div className="icon">
                                                            <i className="fa fa-phone"></i>
                                                        </div>
                                                        <div className="content col-md-8 no-padding">
                                                            <h4 className="text-center">
                                                                {" "}
                                                                <span>{phoneText}</span>
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>}

                                        {useInstantQuote && useInstantQuoteInVDP && (
                                            <InstantQuotePlugin
                                                vin={detail.vin}
                                                hashInstantQuote={detail.hashInstantQuote}
                                            />
                                        )}

                                        {showCheckAvailabilityButton && (
                                            <CheckAvailabiltyButton
                                                data={{
                                                    leadSourceId: vdpSettings.checkAvailabilityLeadSourceId,
                                                    lotId: detail.lotId,
                                                    stock: detail.stockNumber,
                                                    year: detail.year,
                                                    make: detail.make,
                                                    model: detail.model,
                                                    trim: detail.trim,
                                                    price: detail.internetPrice,
                                                    gaCheckAvailabilityCustomCategory,
                                                    gaCheckAvailabilityCustomAction,
                                                    gaCheckAvailabilityCustomLabel,
                                                    gaCheckAvailabilityCustomValue,
                                                }}
                                                text={checkAvailabilityButtonText}
                                            />
                                        )}

                                        {showApplyFinancingButton && (
                                            <FinancingButton
                                                stockNumber={detail.stockNumber}
                                                text={applyFinancingButtonText}
                                                data={{
                                                    gaFinanceCustomCategory,
                                                    gaFinanceCustomAction,
                                                    gaFinanceCustomLabel,
                                                    gaFinanceCustomValue,
                                                }}
                                            />
                                        )}

                                        {actionButtons.length > 0 && actionButtons.map((btn: any, i: number) => (
                                            <ButtonLink item={btn} index={i} key={i} />
                                        ))}

                                        {useCapitalOne && (useCapitalOneInVDP || useCapitalOnePaymentCalculatorInVDP || useCapitalOnePrequalifiedInVDP) && (
                                            <CapitalOnePlugin
                                                scriptCapitalOne={detailOptions.scriptCapitalOne}
                                                codeCapitalOne={codeCapitalOne}
                                                year={detail.year}
                                                miles={detail.miles}
                                                internetPrice={detail.internetPrice}
                                                vin={detail.vin}
                                                image={imageValue}
                                                showCapitalOneButton={useCapitalOneInVDP}
                                                showPaymentCalculator={useCapitalOnePaymentCalculatorInVDP}
                                                usePrequalifiedPage={useCapitalOnePrequalifiedInVDP}
                                                lotName={detail.lotName}
                                            />
                                        )}

                                        {useMonroneyLabel && (
                                            <MonroneyLabel
                                                idMonroneyLabel={idMonroneyLabel}
                                                year={detail.year}
                                                make={detail.make}
                                                vin={detail.vin}
                                            />
                                        )}

                                        {useDealerCenter && useDealerCenterInVDP && (
                                            <DealerCenterPlugin
                                                internetPrice={detail.internetPrice}
                                                vin={detail.vin}
                                                image={imageValue}
                                            />
                                        )}
                                    </div>
                                </div>

                                {(useCarfaxInVDP ||
                                showKBBPriceChart ||
                                showKBBICO ||
                                useMonroneyLabelInVDP ||
                                useEdmundsInVDP ||
                                (useTrueFrame360 && useTrueFrame360InVDP) ||
                                showPureCarsValueReport) && (
                                    <div className="grey-box m-t-20">
                                        {useTrueFrame360 && useTrueFrame360InVDP &&
                                            <TrueFramePlugin vin={detail.vin}
                                                trueFrameScript={trueFrame360Script}
                                                trueFrameType="tf360"
                                            />
                                        }

                                        {useCarfaxInVDP && (
                                            <CarfaxPlugin
                                                partnerIdCarfax={partnerIdCarfax}
                                                companyName={companyInfo.companyName}
                                                vin={detail.vin}
                                                carfaxImageUrl={carfaxImageUrl}
                                                carfaxButtonUrl={detail.carfaxButtonUrl}
                                                carfaxUrl={detail.carfaxUrl}
                                            />
                                        )}

                                        {showKBBPriceChart && (
                                            <KbbChartPlugin
                                                apiKeyKbb={apiKeyKbb}
                                                internetPrice={detail.internetPrice}
                                                vin={detail.vin}
                                            />
                                        )}

                                        {showKBBICO && (
                                            <KbbIcoPlugin
                                                companyName={companyInfo.companyName}
                                                urlKBBICO={urlKBBICO}
                                            />
                                        )}

                                        {useEdmundsInVDP && <EdmundsPlugin />}

                                        {showPureCarsValueReport && <PureCarsPlugin />}
                                    </div>
                                )}

                                {showSocialOptions && (
                                    <div className="grey-box m-t-20">
                                        <SocialOptions />
                                    </div>
                                )}

                                {showPaymentCalculator && (
                                    <div className="grey-box m-t-20">
                                        <PaymentCalculatorForm 
                                            defaultRate={srpSettings.interestRate}
                                            defaultTerm={srpSettings.term}
                                            defaultPrice={detail.internetPrice}
                                        />
                                    </div>
                                )}                                
                            </>
                        )}
                    </div>
                </div>

                {showSimilarVehicles && showSimilarVehiclesInCarousel && (
                    <div ref={similarSection}>
                        {isSimilarVehicleVisible && (
                            <Suspense fallback={<Loading />}>
                                <SimilarVehiclesCarousel
                                    stockNumber={Number(detail.stockNumber)}
                                    companyInfo={companyInfo}
                                    options={{
                                        defaultImageAsThumbnail,
                                        stockPhoto,
                                        forceImageOverSSL,
                                        showSimilarVehiclesMiles,
                                        showSimilarVehiclesLocation,
                                        showSimilarVehiclesPrice,
                                        showVehicleSlashedPrice,
                                        overrideSimilarVehiclesPriceByText,
                                        overrideSimilarVehiclesPriceText,
                                        useOrbeeAuto,
                                        showOrbeeInSimilar,
                                        idOrbeeAuto,
                                        similarCarsToShow,
                                    }}
                                />
                            </Suspense>
                        )}
                    </div>
                )}

                {showDisclaimer && (
                    <div className="col-lg-12 col-md-12 col-xs-12 m-t-20">
                        <div className="col-lg-12 col-md-12 col-xs-12 grey-box">
                            <HtmlComponent htmlValue={disclaimer} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default VDPDesktop;
